export const AGUNG = "Agu.ng";
export const logo = "/logo.png";
